// E-Ticaret › Destek Talepleri sayfası kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'ecommerce.supportTickets';

export const ecommerceSupportTicketsGuide = (t: TFunction): GuideContent => ({
  layout: 'list',
  title: t(`${G}.title`, 'Destek Talepleri nasıl kullanılır?'),
  intro: t(`${G}.intro`, 'E-ticaret sitenizden müşterilerin açtığı destek taleplerini burada görür, yanıtlar ve durumlarını yönetirsiniz. Gerekirse müşteri adına talebi kendiniz de açabilirsiniz. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Destek Talepleri'),
    toolbar: t(`${G}.regions.toolbar`, 'Vitrinde açık / Yenile / Yeni Talep'),
    filters: t(`${G}.regions.filters`, 'Ara ve Durum'),
    table: t(`${G}.regions.table`, 'Talep listesi'),
    pagination: t(`${G}.regions.pagination`, 'Sayfa başına'),
  },
  steps: [
    {
      region: 'toolbar',
      title: t(`${G}.s1.title`, '1. Destek sitede görünsün mü?'),
      text: t(`${G}.s1.text`, 'Başlığın sağındaki anahtar destek bölümünün sitede görünüp görünmeyeceğini belirler ve değiştirdiğiniz anda kaydedilir. "Vitrinde kapalı" yaparsanız müşteriler sitede Destek Taleplerim sayfasını ve menü bağlantısını göremez; siz bu ekrandan mevcut talepleri yönetmeye devam edersiniz.'),
    },
    {
      region: 'filters',
      title: t(`${G}.s2.title`, '2. Talebi bulun'),
      text: t(`${G}.s2.text`, '"Ara" kutusuna talep numarası, konu, müşteri adı ya da e-postasını yazın. "Durum" listesiyle yalnız Açık, İşlemde, Müşteri Bekleniyor, Çözüldü veya Kapalı talepleri gösterin. Yeni gelen talepleri görmek için "Yenile" düğmesine basın.'),
    },
    {
      region: 'table',
      title: t(`${G}.s3.title`, '3. Listeyi okuyun'),
      text: t(`${G}.s3.text`, 'Her satırda Talep No, Müşteri (ve e-postası), Konu, Kategori, Durum, Öncelik ve Tarih görünür. Satırın sağındaki göz simgesi (Detay) talebin bilgilerini ve tüm mesajlarını açar.'),
      tips: [
        t(`${G}.s3.tip1`, 'Kategoriler: Genel, Sipariş, Ödeme, Kargo, Ürün, Diğer. Öncelik: Düşük, Normal, Yüksek.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s4.title`, '4. Yanıt yazın'),
      text: t(`${G}.s4.text`, 'Detay penceresinde müşteri, e-posta, telefon ve kategori bilgisi ile yazışma geçmişi görünür; sizin mesajlarınız sağda, müşterinin mesajları solda durur. "Yanıt yazın" kutusuna mesajınızı yazıp "Yanıt Gönder"e basın; yanıt müşterinin sitedeki talep sayfasında görünür.'),
      tips: [
        t(`${G}.s4.tip1`, 'Siz yanıt yazdığınızda Açık veya Müşteri Bekleniyor durumundaki talep kendiliğinden "İşlemde" olur.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s5.title`, '5. Durumu güncelleyin'),
      text: t(`${G}.s5.text`, 'Detay penceresindeki "Durum" listesinden yeni durumu seçtiğinizde hemen kaydedilir. Sorun giderildiyse "Çözüldü", konuşma bittiyse "Kapalı" seçin.'),
      tips: [
        t(`${G}.s5.tip1`, 'Çözüldü veya Kapalı durumundaki talebe müşteri siteden yeni mesaj yazamaz. Talebi yeniden açmak için durumu Açık ya da İşlemde yapın.'),
      ],
    },
    {
      region: 'toolbar',
      title: t(`${G}.s6.title`, '6. Müşteri adına yeni talep açın'),
      text: t(`${G}.s6.text`, '"Yeni Talep" ile telefonla ya da mağazada gelen bir isteği kayda alabilirsiniz. "Üye (opsiyonel)" listesinden üyeyi seçerseniz ad, e-posta ve telefon kendiliğinden dolar; üye değilse "Misafir / Manuel" bırakıp iletişim bilgilerini yazın. Konu ve Mesaj zorunludur; Kategori, Öncelik ve Sipariş ID isteğe bağlıdır. "Oluştur" ile talep Açık durumunda listeye eklenir.'),
    },
    {
      region: 'pagination',
      title: t(`${G}.s7.title`, '7. Sayfalar arasında gezinin'),
      text: t(`${G}.s7.text`, 'Liste uzunsa alttaki sayfalama ile ilerleyin; "Sayfa başına" ile bir sayfada kaç talep görüneceğini seçin. Başlıktaki (i) düğmesi bu rehberi her zaman yeniden açar.'),
    },
  ],
});
